const getDefaultCredentials = (env) => {
  let clientId = null;
  let secret = null;
  let url = '';
  let audience = '';
  let sdkUrl = '';
  let apiUrl = '';
  const grantType = 'client_credentials';

  if (!env) {
    return { clientId, secret, url, audience, grantType, sdkUrl };
  }

  switch (env.toUpperCase()) {
    case 'PROD':
      url = 'https://auth.snapfinance.com/oauth/token';
      audience = 'https://api.snapfinance.com/platform/v1';
      sdkUrl = 'https://js.snapfinance.com/v2/snap-sdk.js';
      apiUrl = 'https://api.snapfinance.com/platform/v1';
      break;
    case 'SANDBOX':
      clientId = 'WgTe86Fb7AJP1JkdcQlxrfHWGpR8dsyv';
      secret =
        't9vUlYkRz8in_z-7xkdrHZgPRrTYQ97LrxupR6TpbrRnmb1J8WI8A1QHY6fD_D7-';
      url = 'https://auth-sandbox.snapfinance.com/oauth/token';
      audience = 'https://api-release.snapfinance.com/platform/v1';
      sdkUrl = 'https://js.snapfinance.com/sandbox/v2/snap-sdk.js';
      apiUrl = 'https://api-sandbox.snapfinance.com/platform/v1';
      break;
    case 'DEV':
      url = 'https://checkout-dev.auth0.com/oauth/token';
      audience = 'https://api-dev.snapfinance.com/platform/v1';
      sdkUrl = 'https://js-qa-dev.snapfinance.com/dev/v2/snap-sdk.js';
      apiUrl = 'https://api-dev.snapfinance.com/platform/v1';
      break;
    case 'QA':
      url = 'https://api-qa.snapfinance.com/auth0/checkout/merchant/token';
      audience = 'https://api-qa.snapfinance.com/platform/v1';
      sdkUrl = 'https://js-qa-dev.snapfinance.com/qa/v2/snap-sdk.js';
      apiUrl = 'https://api-qa.snapfinance.com/platform/v1';
      break;
    case 'UAT':
      url = 'https://checkout-stable.auth0.com/oauth/token';
      audience = 'https://api-stable.snapfinance.com/platform/v1';
      sdkUrl = 'https://js-qa-dev.snapfinance.com/stable/v2/snap-sdk.js';
      apiUrl = 'https://api-stable.snapfinance.com/platform/v1';
      break;
    default:
      break;
  }
  return { clientId, secret, url, audience, apiUrl, grantType, sdkUrl };
};

export default getDefaultCredentials;
